import { object, array, mixed } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';
import { getRewardValueValidationSchema } from '@shared/utils';

import { UserRewardType } from 'v2/constants';

export const referralUserRewardSettingsSchema = object().shape({
  personalChance: array().of(
    object().shape({
      type: mixed().oneOf(Object.values(UserRewardType)).required(YUP_ERRORS_MESSAGES.REQUIRED),
      value: getRewardValueValidationSchema(),
    })
  ),
});
